import { useLocation, useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import { getEngagementBase } from '../engagementPaths';
import { ENGAGEMENT_NAV_ROUTES } from './navConfig';

export default function EngagementBreadcrumb() {
  const navigate = useNavigate();
  const location = useLocation();
  const base = getEngagementBase().replace(/\/+$/, '');
  if (!base || !location.pathname.startsWith(base)) return null;

  const parentPath = base.includes('/partner/') ? '/naturals/partner/overview' : '/naturals/login';
  const tail = location.pathname.slice(base.length).replace(/^\//, '').split('/')[0];
  const current =
    ENGAGEMENT_NAV_ROUTES.find((item) => item.segment === tail)?.label ||
    (tail ? tail.replace(/-/g, ' ') : 'Dashboard');

  return (
    <div className="portal-breadcrumb flex items-center gap-2">
      <button
        type="button"
        onClick={() => navigate(parentPath)}
        className="portal-breadcrumb__back"
        title="Back to overview"
      >
        <IoArrowBack size={18} />
      </button>
      <span className="portal-breadcrumb__sep" aria-hidden="true">/</span>
      <span className="portal-breadcrumb__current">{current}</span>
    </div>
  );
}
